module.exports = __webpack_public_path__ + "img/date.868f2d75.svg";